/**
 * Error codes the Show Info Library endpoints answer with, mirrored from
 * api-v2's `apps/api/src/core/glossary/static/constants.ts`.
 */
export const LIBRARY_CATEGORY_NAME_EXISTS = "LIBRARY_CATEGORY_NAME_EXISTS";
export const LIBRARY_CATEGORY_NAME_EXISTS_IN_ARCHIVE =
  "LIBRARY_CATEGORY_NAME_EXISTS_IN_ARCHIVE";
export const LIBRARY_CATEGORY_HAS_LINKS = "LIBRARY_CATEGORY_HAS_LINKS";

export const LIBRARY_SECTION_NAME_EXISTS = "LIBRARY_SECTION_NAME_EXISTS";
export const LIBRARY_SECTION_NAME_EXISTS_IN_ARCHIVE =
  "LIBRARY_SECTION_NAME_EXISTS_IN_ARCHIVE";
export const LIBRARY_SECTION_HAS_LINKS = "LIBRARY_SECTION_HAS_LINKS";

export const SHOW_INFO_IMPORT_CONFLICTS = "SHOW_INFO_IMPORT_CONFLICTS";
export const SHOW_INFO_PUSH_CONFLICT = "SHOW_INFO_PUSH_CONFLICT";

/**
 * The internal name's shape, kept in step with api-v2's DTO. Pending the
 * data-dictionary rows (FS-2890 Q5) this follows FTD-58's `optionId`.
 */
export const INTERNAL_NAME_MAX_LENGTH = 50;
export const INTERNAL_NAME_PATTERN = /^[A-Za-z0-9/\\_-]+$/;

/** A section title's limit, in step with api-v2's `TITLE_MAX_LENGTH`. */
export const TITLE_MAX_LENGTH = 256;

/** Pagination is over category rows, per the design's `Rows per page: 100`. */
export const ROWS_PER_PAGE = 100;
